window.GateStepsModule = (function(w, $) {
    const settings = {
      distanceScrolled: 0,
    };

    // initialize Module
    const init = () => {
      const _s = settings;
      // console.log('initialize Gate Steps Module');

      bindUIActions(_s);
    };

    function bindUIActions(_s) {
      $(window).on('scroll touchmove', function() {
        updateDistanceScrolled(_s);

        if($('.steps__item--changer').length) {
          $('.steps__item--changer .steps__item__images').each(function() {
            stepImageIconChanger(_s, $(this));
          });
        }

        if($('.steps__item--scroller .desktop__inner').length) {
          $('.steps__item--scroller .desktop__inner').each(function() {
            
            if ($(this).hasClass('moves')) {

              stepMockupScroller(_s, $(this));
                
            }
            
          });
        }

        if($('.steps-line').length) {
          $('.steps-line').each(function() {
            animateLine(_s, $(this));
          });
        }
      });
    }

    function updateDistanceScrolled(_s) {
      _s.distanceScrolled = $(window).scrollTop();
    }

    function animateLine(_s, element) {
      var elementTop = element.offset().top - window.viewport().height;

      if (_s.distanceScrolled > elementTop) {
        element.addClass('is-visible');
      }
    }

    function stepImageIconChanger(_s, element) {
      var elementMiddle = element.offset().top - (window.viewport().height / 2);
      var elementBottom = elementMiddle + element[0].offsetHeight;

      var heroFeedHeightWithOffset = 0;
      if($(window).width() > 800) {
          
        //Set this to 0 as the hero isn't there anymore -Jesse
        heroFeedHeightWithOffset = 0;
        //heroFeedHeightWithOffset = $('#js-hero-feed')[0].offsetHeight - 35 - 14 - 10;
      }

      if (_s.distanceScrolled < elementMiddle) {
        element.parent().removeClass('steps__item--2 steps__item--3').addClass('steps__item--1');
      } else if (_s.distanceScrolled > elementMiddle && _s.distanceScrolled + heroFeedHeightWithOffset < elementBottom) {
        element.parent().removeClass('steps__item--1 steps__item--3').addClass('steps__item--2');
      } else if (_s.distanceScrolled + heroFeedHeightWithOffset > elementBottom) {
        element.parent().removeClass('steps__item--1 steps__item--2').addClass('steps__item--3');
      }
    }

    function stepMockupScroller(_s, element) {
      var elementBottom = element.offset().top - window.viewport().height + element[0].offsetHeight;

      var elementImage = element.find('img.moves');
      var elementImageHeight = elementImage[0].offsetHeight;
      var elementHeight = element[0].offsetHeight;

      var regular = (_s.distanceScrolled - elementBottom) / 2;
      var limited = elementImageHeight - elementHeight;

      var transform = regular > limited ? limited : regular;

      if(_s.distanceScrolled > elementBottom) {
        elementImage.css({
          'transform': `translateY(-${transform}px)`,
          '-webkit-transform': `translateY(-${transform}px)`
        });
      } else {
        elementImage.css({
          'transform': `translateY(0px)`,
          '-webkit-transform': `translateY(0px)`
        });
      }
    }

    return { init };
})(window, jQuery)
